module.exports = __webpack_public_path__ + "static/media/19_B.44cb59a6.png";